import jwtDecode from 'jwt-decode';

import type { AuthSession, Credentials } from '../interfaces';

export class AuthSessionClient<T> implements AuthSession<T> {
  private readonly accessTokenExpiry: number;
  private readonly idTokenExpiry: number;
  private readonly user: T;

  static createSession<T>(credentials: Credentials): AuthSession<T> {
    return new AuthSessionClient(credentials);
  }

  static getTokenExpiry(token: string): number {
    const data = jwtDecode(token) as BaseToken;

    const epoch = data.exp;
    const expiry = epoch * 1000;

    return expiry;
  }

  static isExpired(expiry: number, reference: number): boolean {
    return expiry < reference;
  }

  constructor(private readonly credentials: Credentials) {
    const { idToken, accessToken } = credentials;
    this.user = jwtDecode<T>(idToken);
    this.accessTokenExpiry = AuthSessionClient.getTokenExpiry(accessToken);
    this.idTokenExpiry = AuthSessionClient.getTokenExpiry(idToken);
  }

  isValid(): boolean {
    const now = Date.now();
    const accessIsValid = !AuthSessionClient.isExpired(
      this.accessTokenExpiry,
      now,
    );
    const idIsValid = !AuthSessionClient.isExpired(this.idTokenExpiry, now);

    return idIsValid && accessIsValid;
  }

  getUser(): T {
    return this.user;
  }

  getAccessToken(): string {
    return this.credentials.accessToken;
  }

  getIdToken(): string {
    return this.credentials.idToken;
  }

  getRefreshToken(): string {
    return this.credentials.refreshToken;
  }
}

interface BaseToken {
  exp: number;
}
